<div class="card leaderboard-card rounded" [class.widget]="isWidget">
  <div class="nav d-flex align-items-center justify-content-center leaderboard-navigation rounded w-100 align-self-center">
    <a class="nav-item w-50 text-center" [ngClass]="{ selected: showMonthly }" (click)="initializeMonthlyLeaderboard()">
      <label class="font-size-12 fw-bold text-center mb-0">{{ 'leaderboard.v2.monthly' | translate }}</label>
    </a>
    <a class="nav-item w-50 text-center" [ngClass]="{ selected: !showMonthly }" (click)="initializeLeaderboard()">
      <label class="font-size-12 fw-bold text-center mb-0">{{ 'leaderboard.v2.yearly' | translate }}</label>
    </a>
  </div>
  <div class="leaderboard-nav" *ngIf="showMonthly; else yearly">
    <owl-carousel-o [options]="customOptions" (translated)="onSlideChanged($event)">
      <ng-template carouselSlide *ngFor="let item of monthlyLeaderboard; let i = index">
        <div class="py-2 leaderboard-date-toggle">
          <div class="text-center fw-bold font-size-14 m-0 text-white">{{ item.month | date : 'MMMM' }}</div>
        </div>
        <!-- Loading state -->
        <div *ngIf="loadingMonth === i" class="text-center py-3">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        <div *ngIf="item.loaded && item.entries.length > 0">
          <div class="mt-4 ranking-list">
            <ng-container
              *ngTemplateOutlet="leaderboardItemListTemplate; context: { $implicit: item.entries, topThree, challengers }"
            >
            </ng-container>
          </div>
        </div>
        <div *ngIf="item.loaded && item.entries.length === 0">
          <div class="leaderboard-placeholder rounded">
            <img class="placeholder-image" src="assets/images/placeholders/leaderboard-placeholder.svg" />

            <div class="fw-bold font-size-14 text-white text-center">
              {{ 'leaderboard.no.entries' | translate }}
            </div>
          </div>
        </div>
      </ng-template>
    </owl-carousel-o>

    @if (isWidget) {
    <div class="leaderboard-button text-center w-100">
      <a class="fw-bold font-size-14 text-white" [routerLink]="['/leaderboard']">{{
        'pick.player.view.full.leaderboard' | translate
      }}</a>
    </div>
    }
  </div>
  <ng-template #yearly>
    <div class="py-3 pt-3 text-center font-size-14">
      <!-- Loading state -->
      <div *ngIf="loadingYear" class="text-center py-3">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <div *ngIf="!loadingYear && yearlyLeaderboards.length > 0">
        <div class="mt-3 ranking-list">
          <ng-container
            *ngTemplateOutlet="leaderboardItemListTemplate; context: { $implicit: yearlyLeaderboards, topThree, challengers }"
          >
          </ng-container>
        </div>
      </div>
      <div *ngIf="!loadingYear && yearlyLeaderboards.length === 0">
        <div class="leaderboard-placeholder rounded">
          <img class="placeholder-image" src="assets/images/placeholders/leaderboard-placeholder.svg" />

          <div class="fw-bold font-size-14 text-white text-center">
            {{ 'leaderboard.no.entries' | translate }}
          </div>
        </div>
      </div>
    </div>

    @if (isWidget) {
    <div class="leaderboard-button text-center w-100">
      <a class="fw-bold font-size-14 text-white" [routerLink]="['/leaderboard']">{{
        'pick.player.view.full.leaderboard' | translate
      }}</a>
    </div>
    }
  </ng-template>
</div>

<ng-template #leaderboardItemListTemplate let-items let-topThree="topThree" let-challengers="challengers">
  <ng-container *ngFor="let item of topThree">
    <div
      class="font-size-14 fantasy-row"
      [ngClass]="{ first: item.tier === 'gold', second: item.tier === 'silver', third: item.tier === 'bronze' }"
    >
      <div class="rank-item">
        <div class="rank-number fw-bold">
          @if (item.tier === 'gold') {
          <span class="material-symbols-outlined">crown</span>
          } @else {
          {{ item.Position }}
          }
        </div>
        <div class="rank-name text-capitalize fw-bold">{{ item.FullName | initials : true }}.</div>
        <div class="rank-points">
          {{ item.Points / 100 | FortressCurrencyPipe : 'PTS' }}
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngFor="let item of challengers">
    <div class="font-size-14 fantasy-row fantasy-row-users" [ngClass]="{ 'current-user text-tertiary': item.IsCurrentUser }">
      <div class="rank-item">
        <div class="rank-number fw-bold">
          {{ item.Position }}
        </div>
        <div class="rank-name text-capitalize fw-bold">{{ item.FullName | initials : true }}.</div>
        <div class="rank-points">
          {{ item.Points / 100 | FortressCurrencyPipe : 'PTS' }}
        </div>
      </div>
    </div>
  </ng-container>
  @if (isWidget && currentUser && currentUser.Position > 3) {
  <div class="font-size-14 fantasy-row current-user mt-3 text-tertiary">
    <div class="rank-item">
      <div class="rank-number fw-bold">
        {{ currentUser.Position }}
      </div>
      <div class="rank-name text-capitalize fw-bold">{{ currentUser.FullName | initials : true }}.</div>
      <div class="rank-points">
        {{ currentUser.Points / 100 | FortressCurrencyPipe : 'PTS' }}
      </div>
    </div>
  </div>
  }
</ng-template>
